import { render, staticRenderFns } from "./w-support-email-address.global.vue?vue&type=template&id=4f84f084"
import script from "./w-support-email-address.global.vue?vue&type=script&lang=js"
export * from "./w-support-email-address.global.vue?vue&type=script&lang=js"
import style0 from "./w-support-email-address.global.vue?vue&type=style&index=0&id=4f84f084&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
